@if ((energyEnabled$ | async) && class === 'fixed') {
  <button class="energy-settings-button rounded-circle border border-0" [ngClass]="class" (click)="openEnergySettingsDialog()">
    <i class="fa-kit fa-thin-gear-circle-bolt"></i>
  </button>
}

@if ((energyEnabled$ | async) && class === 'absolute') {
  <button class="energy-settings-button rounded-circle border border-0" [ngClass]="class" (click)="openEnergySettingsDialog()">
    <i class="fa-kit fa-thin-gear-circle-bolt"></i>
  </button>
}

@if ((energyEnabled$ | async) && class === 'inflation') {
  <button class="energy-settings-button rounded-circle border border-0" [ngClass]="class" (click)="openEnergySettingsDialog()">
    <i class="fa-kit fa-thin-gear-circle-bolt"></i>
  </button>
}

